module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5eg9Z"))).then(() => parcelRequire('ljYL6'));